<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mx-auto" :loading="loading">
        <v-card-title>Filtri di ricerca</v-card-title>
        <v-card-subtitle>Cerca tra le attività</v-card-subtitle>

        <v-card-text>
          <v-row>
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Data</v-subheader>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="5" xs="6">
              <v-menu ref="refFromPickerMenu" v-model="fromPicker" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="formattedFrom" v-on="on" placeholder="Inizio" :rules="requiredRules" single-line filled dense required clearable></v-text-field>
                </template>
                <v-date-picker v-model="from" locale="it-it" :max="to" no-title scrollable @change="fromPicker = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col xl="5" lg="5" md="5" sm="5" xs="6">
              <v-menu ref="refToPickerMenu" v-model="toPicker" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field :value="formattedTo" v-on="on" placeholder="Fine" :rules="requiredRules" single-line filled dense required clearable></v-text-field>
                </template>
                <v-date-picker v-model="to" locale="it-it" :min="from" no-title scrollable @change="toPicker = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Area</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select v-model="areaId" placeholder="Tutte le aree di pertinenza" :items="areas" item-value="id" item-text="description" 
                no-data-text="Nessuna area presente" @change="selectActivities()" single-line filled dense required clearable>
              </v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Attività</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select v-model="activityId" placeholder="Tutte le attività" :items="activities" item-value="id" item-text="description" 
                no-data-text="Nessuna attività presente" single-line filled dense required clearable>
              </v-select>
            </v-col>
          </v-row>

          <v-row style="margin-top: -25px;" v-if="isAdmin">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Utente</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select v-model="userId" placeholder="Tutte gli utenti" :items="users" item-value="id" item-text="fullName" 
                no-data-text="Nessuna utente configurato" single-line filled dense required clearable>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn small dark color="grey" @click="reset()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" @click="dialog = false">Chiudi</v-btn>
          <v-btn small dark color="green" :disabled="!(valid)" :loading="loading" @click="search()">Cerca</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import apiRepository from '../../api/api-repository';

moment.locale('it');

export default {
  name: 'SearchFilters',

  data: ()=> ({
    // flag di gestione del componente.
    lazy: true, // tipo di validazione del form.
    valid: true, // stato di validazione del form.
    dialog: false, // apre/chiude la dialog contenente il form.
    loading: false, // abilita/disabilita il caricamento durante l'operazione.
    fromPicker: false, // apre/chiude il calendario della data di inizio.
    toPicker: false,  // apre/chiude il calendario della data di fine.
    // campi del form contenente i filtri di ricerca.
    from: moment().isoWeekday(1).format('YYYY-MM-DD'),
    to: moment().isoWeekday(7).format('YYYY-MM-DD'),
    areaId: null, activityId: null, userId: null,
    // liste di selezione.
    areas: new Array(), // lista delle aree di pertinenza.
    activities: new Array(), // lista delle attività degli utenti.
    users: new Array(), // lista degli utenti attivi della scuola.
    // regole per i campi obbligatori.
    requiredRules: [ (v)=> !!v || 'Campo obbligatorio' ], // campo obbligatorio.
  }),

  computed: {
    ...mapGetters('oidcStore', [ 'oidcUser' ]),

    formattedFrom(){
      return (this.from) ? moment(this.from).format('DD/MM/YYYY') : '';
    },

    formattedTo(){
      return (this.to) ? moment(this.to).format('DD/MM/YYYY') : '';
    },

    isAdmin(){
      return (this.oidcUser.licenses.includes('WTR') && this.oidcUser.roles.includes('wtr.admin'));
    }
  },

  methods: {
    open(){
      this.valid = true; // setto il flag di validità del form.
      this.dialog = true; // apro la dialog contenente il form.
    },

    reset(){
      this.$refs.form.reset();
      this.$refs.form.resetValidation(); // resetto la validazione del form.
      this.activities = new Array();
      this.from = moment().isoWeekday(1).format('YYYY-MM-DD');
      this.to = moment().isoWeekday(7).format('YYYY-MM-DD');
    },

    search(){
      // se il form non è valido esco dal salvataggio.
      if(!this.$refs.form.validate()) return;
      // form valido, proseguo con il salvataggio.
      this.loading = true; // setto il form in caricamento.
      // preparo la richiesta di ricerca da mettere.
      let filters = { 
        from: this.from, to: this.to,
        area: this.areas.find((x)=> this.areaId === x.id),
        activity: this.activities.find((x)=> this.activityId === x.id),
        user: (this.isAdmin) ? this.users.find((x)=> this.userId === x.id) : null
      };
      
      this.loading = false;
      this.dialog = false;
      this.$emit('filters', filters);
    },

    async selectActivities(){
      this.activityId = null; // resetto il valore dell'attività precedentemente selezionata.
      const res = await apiRepository.activities().findByAreaId(this.areaId); // attendo la risposta dalla api.
      this.activities = res.data; // assegno alla lista del componente le attività trovate.
    },

    async init(){
      // recupero le aree di pertinenza dalle api.
      const areaRes = await apiRepository.area().findAll(); // attendo la risposta dalla api.
      this.areas = areaRes.data; // assegno alla lista del componente le aree trovate.
      // recupero gli utenti associati alla scuola dalle api.
      if(this.isAdmin){
        const userRes = await apiRepository.users().findAll(); // attendo la risposta dalla api.
        this.users = userRes.data; // assegno alla lista del componente gli utenti trovati.
      }
    }
  },

  created(){
    this.init();
  }
}
</script>